var $cc55cdc99bceb75c$exports = {};
$cc55cdc99bceb75c$exports = {
    "(optional)": `(facultatif)`,
    "(required)": `(requis)`
};


export {$cc55cdc99bceb75c$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
